<aumico-users-edit-general-information-component
    [user]="user"
    [countries]="countries"
    [userCountry]="userCountry"
    (userProfileGeneralInformationChange)="modifyUserProfileInformation($event)"
    [supportedLocales]="supportedLocales"
>
</aumico-users-edit-general-information-component>
